// extracted by mini-css-extract-plugin
export var layoutContainer = "_3j-0";
export var layoutContainerOpen = "_3j-3";
export var mainContent = "_3j-1";
export var panelLarge = "_3j-6";
export var panelMedium = "_3j-5";
export var panelSmall = "_3j-4";
export var slidePanel = "_3j-2";